import { useState } from 'react';
import { sendPasswordResetEmail } from 'firebase/auth';
import { Link } from 'react-router-dom';
import AuthLayout from '../components/AuthLayout';
import { TextField } from '../components/FormFields';
import { auth } from '../firebaseConfig';
import { OFFLINE_REQUIRED, requireConnectionForMutation } from '../services/connectivityService';
import './login.css';

function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleResetPassword = async (event) => {
    event.preventDefault();
    setError('');
    setMessage('');
    setIsSubmitting(true);

    try {
      requireConnectionForMutation();
      await sendPasswordResetEmail(auth, email);
      setMessage('Enviamos um link de recuperação para o seu e-mail.');
    } catch (resetError) {
      setError(resetError?.code === OFFLINE_REQUIRED
        ? 'Esta operação exige conexão. Conecte-se e tente novamente.'
        : 'Não foi possível enviar o link. Verifique o e-mail e tente novamente.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <AuthLayout
      title="Recuperar senha"
      subtitle="Informe seu e-mail e enviaremos um link para você criar uma nova senha."
    >
      <form className="auth-form" onSubmit={handleResetPassword}>
        {message && <div className="auth-alert auth-alert--success" role="status">{message}</div>}
        {error && <div className="auth-alert auth-alert--error" role="alert">{error}</div>}
        <TextField
          id="recovery-email"
          label="E-mail"
          type="email"
          inputMode="email"
          autoComplete="email"
          value={email}
          onChange={setEmail}
          required
          disabled={isSubmitting}
        />
        <button className="auth-primary-button" type="submit" disabled={isSubmitting}>
          {isSubmitting ? 'Enviando…' : 'Enviar link de recuperação'}
        </button>
      </form>
      <p className="auth-switch"><Link to="/login">Voltar para entrar</Link></p>
    </AuthLayout>
  );
}

export default ForgotPassword;
